import script from "./NottificationAttacmentFiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./NottificationAttacmentFiles.vue?vue&type=script&lang=ts&setup=true"

import "./NottificationAttacmentFiles.vue?vue&type=style&index=0&id=1f9e06e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9e06e4"]])

export default __exports__